import { render, staticRenderFns } from "./Insumos.vue?vue&type=template&id=f0550736&scoped=true"
import script from "./Insumos.vue?vue&type=script&lang=js"
export * from "./Insumos.vue?vue&type=script&lang=js"
import style0 from "./Insumos.vue?vue&type=style&index=0&id=f0550736&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0550736",
  null
  
)

export default component.exports